import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  DealContactRequest,
  DealContactResponse,
  DealContactRoleResponse
} from '../models/deal.model';

@Injectable({
  providedIn: 'root'
})
export class DealContactApiService {
  private readonly apiUrl = `${environment.apiUrl}api`;

  constructor(private http: HttpClient) { }

  // POST /api/deal-contacts - Create association (businessId in body)
  createAssociation(request: DealContactRequest): Observable<DealContactResponse> {
    return this.http.post<DealContactResponse>(`${this.apiUrl}/deal-contacts`, request);
  }

  // GET /api/deal-contacts/{id}?businessId= - Get by ID
  getById(id: number, businessId: number): Observable<DealContactResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<DealContactResponse>(`${this.apiUrl}/deal-contacts/${id}`, { params });
  }

  // PUT /api/deal-contacts/{id}?businessId= - Update association
  updateAssociation(id: number, request: DealContactRequest, businessId: number): Observable<DealContactResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.put<DealContactResponse>(`${this.apiUrl}/deal-contacts/${id}`, request, { params });
  }

  // DELETE /api/deal-contacts/{id}?businessId= - Delete association (204)
  deleteAssociation(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.apiUrl}/deal-contacts/${id}`, { params });
  }

  // POST /api/deal-contacts/{id}/set-primary?businessId= - Mark as primary
  setPrimary(id: number, businessId: number): Observable<DealContactResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.post<DealContactResponse>(`${this.apiUrl}/deal-contacts/${id}/set-primary`, null, { params });
  }

  // GET /api/deal-contacts/by-deal/{idDeal}?businessId= - All contacts for a deal
  getByDeal(idDeal: number, businessId: number): Observable<DealContactResponse[]> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<DealContactResponse[]>(`${this.apiUrl}/deal-contacts/by-deal/${idDeal}`, { params });
  }

  // GET /api/deal-contacts/by-contact/{idContact}?businessId= - All deals for a contact
  getByContact(idContact: number, businessId: number): Observable<DealContactResponse[]> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<DealContactResponse[]>(`${this.apiUrl}/deal-contacts/by-contact/${idContact}`, { params });
  }

  // GET /api/deal-contact-roles/active?businessId= - Active role catalog
  getActiveRoles(businessId: number): Observable<DealContactRoleResponse[]> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<DealContactRoleResponse[]>(`${this.apiUrl}/deal-contact-roles/active`, { params });
  }
}
